import { callNative as toNative, initNativeCalls } from '@ifit/native-webview-interface';
import pubsub from './pub-sub';
import { FacebookIntegrationCancelled } from '../errors';
import { updateSignInWithApple } from '../store/ducks/apple';
import { loadUserEmail, loginViaPlanetFitnessSSO } from '../store/ducks/user';
import { Navigation } from '../navigation/react-redux-nav';
import getNavData from '../navigation/get-nav-data';

export function initNativeBridge(store = {}) {
  initNativeCalls(store, [
    (payload) => {
      const { methodName, ...rest } = payload;
      pubsub.emit(methodName, { ...rest, store });
    }
  ]);
}

function callNative(methodName, payload = {}) {
  return toNative({ methodName, ...payload });
}

function listenForUpdates() {
  pubsub.on('SetInitialConfigValues', async ({ store, ...configValues }) => {
    if (configValues.signInWithAppleEnabled !== undefined) {
      store.dispatch(updateSignInWithApple(configValues.signInWithAppleEnabled));
    }

    if (configValues.planetFitnessSSOCode !== undefined) {
      try {
        await store.dispatch(loginViaPlanetFitnessSSO(configValues.planetFitnessSSOCode));
      } catch (e) {
        // fail silently for now
      }
    }
  });
}

function getConfigValuesFromNative() {
  return new Promise((resolve) => {
    pubsub.once('SetInitialConfigValues', ({ store, ...configValues }) => {
      resolve(configValues);
    });
  });
}

function getPlanetFitnessAuth() {
  callNative('LoginWithPlanetFitness');

  return new Promise((res, rej) => {
    pubsub.once('PFLoginResponse', ({ store, ...data }) => {
      if (data.error) {
        rej(data.error);
        return;
      }

      res(data);
    });
  });
}

function logInWithApple() {
  callNative('LoginWithApple');
  return new Promise((res, rej) => {
    pubsub.once('AppleLoginResponse', ({ store, ...data }) => {
      res(data);
    });
  });
}

function getUserFacebookProfileFromNative() {
  callNative('GetFacebookProfileInfo');

  // const payloadFromFacebookWinkWink = {
  //   birthday: '07/29/1984',
  //   email: 'rlauer@gmail.com',
  //   name: 'Bob Lauer',
  //   gender: 'male',
  //   id: '41601712',
  //   accessToken: 'need to get this from https://developers.facebook.com/tools/explorer/480714405275595'
  // };

  // return Promise.resolve(payloadFromFacebookWinkWink);

  return new Promise((resolve, reject) => {
    const successEvent = pubsub.once('SetFacebookProfileInfo', ({ store, ...profileData }) => {
      failureEvent.end();
      resolve(profileData);
    });

    const failureEvent = pubsub.once('CancelFacebookProfileInfo', () => {
      successEvent.end();
      reject(new FacebookIntegrationCancelled());
    });
  });
}

function makePaymentFromNative(payload) {
  callNative('MakePayment', payload);

  return new Promise((resolve, reject) => {
    const successEvent = pubsub.once('PaymentCompleted', ({ store }) => {
      failureEvent.end();
      resolve();
    });

    const failureEvent = pubsub.once('PaymentFailed', () => {
      successEvent.end();
      reject(new Error('Payment failed.'));
    });
  });
}

function onboardingCompleted(payload) {
  callNative('OnboardingCompleted', payload);
}

function setAuthCredentials(payload) {
  callNative('SetAuthCredentials', payload);
}

function manualActivationCompleted() {
  callNative('ManualActivationCompleted');
}

function openUrl(payload) {
  callNative('OpenUrl', payload);
}

function setNewUserEmail(payload) {
  callNative('SetNewUserEmail', payload);
}

function closeWebview() {
  callNative('CloseWebview');
}

function redirectToLogin() {
  callNative('RedirectToLogin');
}

function pageChange(payload) {
  callNative('PageChange', payload);
}

export function addKeyboardListener(callback) {
  return pubsub.on('keyboard', callback);
}

export function goBack({ store }) {
  const { page, config: { appName }, navigationFlow: { flowType } } = store.getState();
  const { currentIndex } = getNavData(appName, flowType, page);
  if (currentIndex !== 0) {
    store.dispatch(Navigation.backward());
  }
}

pubsub.on('SetEmail', ({ store, email }) => {
  store.dispatch(loadUserEmail(email));
});

pubsub.on('GoBack', goBack);

export default {
  getConfigValuesFromNative,
  getPlanetFitnessAuth,
  listenForUpdates,
  logInWithApple,
  getUserFacebookProfileFromNative,
  makePaymentFromNative,
  onboardingCompleted,
  setAuthCredentials,
  manualActivationCompleted,
  openUrl,
  setNewUserEmail,
  closeWebview,
  redirectToLogin,
  pageChange
};
